import Vue from 'vue'
import Router from 'vue-router'
import router from '@/router'
import store from '@/store/index'
import {
    appCurrentPosition
} from "@/utils/native";
import {
    openLink
} from "@/utils/bridge";
// 统一注入组件，方便维护
// 全局注入弹窗组件
import dialog from '@/utils/dialog'
Vue.prototype.dialog = dialog
// 全局注入遮罩、提示组件
import toast from '@/utils/toast'
Vue.prototype.toast = toast

// 修复某些情况下路由切换报错的问题
// 例如首次请求页面为UserHome页面时,因为权限检查会跳转到UserLogin页面授业登录,然后再跳转回UserHome页面,此时路由就会出错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

// 全局注入方法
Vue.mixin({
    // 路由进入当前页面时
    beforeRouteEnter(to, from, next) {
        // 根据路由中meta.previous判断是否缓存当前页面
        if (to.meta.previous) {
            // console.log('上级页面', to.meta.previous);
            // 进入下一页缓存当前页
            store.dispatch("keep/push", to.name);
        }
        next();
    },
    // 路由切换离开当前页面时
    beforeRouteLeave(to, from, next) {
        // 根据路由中meta.previous来判断是是返回上一页还是跳转到新页面
        const me = this,
            previous = from.meta.previous,
            // 目标页面
            toName = to.name;
        if (previous) {
            // 可以根据这个来判断是返回上一页还是进入新页面
            if (previous.includes(toName)) {
                // 执行返回函数
                me.viewBack && me.viewBack();
                // 返回上一页,移除当前页缓存
                store.dispatch("keep/pop", from.name);
                // console.log('移除当前页缓存', fromName)
            }
        } else if (store.state.keep.alwaysKeepIncluded.includes(toName)) {
            // 如果页面进入到了始终缓存页面，清除所有缓存
            store.dispatch("keep/removeAll");
        }
        next();
    },
    methods: {
        // 跳转页面
        go(name, params) {
            // if (name == 'MoneyExchangeHome') {
            //     // 测试人员id
            //     if ([1, 2, 8, 49].indexOf(this.$store.state.userInfo.id) < 0) {
            //         name = '';
            //     }
            // }
            if (name) {
                this.$router.push({
                    name: name,
                    // 用于清空参数
                    params: params || {
                        id: ""
                    }
                });
            } else {
                this.toast.show("敬请期待");
            }
        },
        replaceGo(name, params) {
            if (name) {
                this.$router.replace({
                    name: name,
                    params: params
                });
            }
        },
        bannerGo(url) {
            openLink(url);
        },
        backGo() {
            this.$router.go(-1);
        }
    }
})

// 监听路由
router.beforeEach((to, from, next) => {
    const name = to.name;
    const state = store.state
    // console.log('目标页面:', name, ',是否需要登录校验:', state.unCkLoginList.indexOf(name) > -1)
    if (state.isApp) {
        // 用于安卓判断是否在主页面
        const isApphome = ["ShopHome", "ClassifyHome", "CartTab", "UserHome"].indexOf(name) != '-1' ? 1 : 2;
        appCurrentPosition(isApphome);
    }

    // 把校验逻辑写在这里避免一些错误
    if ((state.unCkLoginList.indexOf(name) == '-1')) {
        // console.log('当前登录状态:', store.state.isLogin);
        // 如果没有登录则调整到登录界面
        if (!state.isLogin) {
            state.targetView = name;
            // 跳转到登录界面
            next({
                name: 'UserLogin'
            })
        } else {
            next()
        }
    } else {
        next()
    }
    state.tabSelectIndex = to.name
})